import { Box, List } from "@mui/material";
import { NavItem } from "./sidebar-item";
import Drawer from "@mui/material/Drawer";
import { MobileItem } from "./mobile-item";
import { drawerWidth } from "../../utils/constants";
import { MuiDrawer, DrawerHeader } from "./sidebar-styles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { handleMobileDrawerClose } from "../../features/dashboard/dashboardSlice";
import LogoImg from "../../assets/icons/logo.svg";
import Logo2Img from "../../assets/icons/logo-small.svg";
import { ClinicCms, SidebarItems, SidebarOtherItems } from "./sideBarItem";
import { getClinicData } from "../../features/clinicCms/clinicSlice";
import { useCallback, useEffect, useState } from "react";
import { openInNewTab } from "../../utils/utils";
import {
  getAllPharmacyPermission,
  getStaffPerById,
} from "../../features/staff/staffSlice";
import { useSelector } from "react-redux";

export const DashboardSidebar = ({ lgUp, clinicId }: any) => {
  const { drawer, mobileDrawer } = useAppSelector((state) => state?.dashboard);
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const [staffPermission, setStaffPermission] = useState<any>([]);
  const [isClinicPharmacy, setIsClinicPharmacy] = useState<any>();
  const [activeMenuId, setActiveMenuId] = useState<number | null>(null);
  const handleMenuClick = (id: number) => {
    setActiveMenuId((prevId) => (prevId === id ? null : id));
  };

  const FilteredSidebarItems =
    Account_Type === 1
      ? SidebarItems.filter((item) => {
          if (item.id === 1) return true;

          const isParentMatch = staffPermission.some(
            (permission: any) => permission.path_name === item.href
          );

          const filteredSubItems =
            item?.subItems?.filter((subItem: any) =>
              staffPermission.some(
                (permission: any) => permission.path_name === subItem.href
              )
            ) || [];

          if (filteredSubItems.length > 0) {
            item.subItems = filteredSubItems;
          }

          return isParentMatch || filteredSubItems.length > 0;
        })
      : SidebarItems;

  const dispatch = useAppDispatch();
  const storedData: any = localStorage.getItem("authToken");
  const parsedData = JSON.parse(storedData);
  const { staff_id } = useSelector((state: any) => state?.staff);
  const staff_data = localStorage?.getItem("staff_data");
  const StaffData = staff_data ? JSON?.parse(staff_data) : null;
  const getClinic = useCallback(() => {
    dispatch(getClinicData(parsedData?.clinic_id))
      .then((res) => {
        setIsClinicPharmacy(res);
      })
      .catch((error) => {
        console.error("Error fetching clinic data:", error);
      });
  }, [dispatch, parsedData?.clinic_id]);

  const getStaffPermissionsById = useCallback(() => {
    const obj: any = {
      staff_id: staff_id || StaffData?.id,
      pharmacy_id: pharmacyId,
    };
    dispatch(getStaffPerById(obj)).then((res: any) => {
      if (res?.payload?.success === true) {
        const data = Array.isArray(res?.payload?.data)
          ? res?.payload?.data
          : [];
        setStaffPermission(data);
      } else {
        setStaffPermission([]);
      }
    });
  }, [dispatch, pharmacyId, staff_id]);

  const GetAllStaffPermissions = useCallback(() => {
    dispatch(getAllPharmacyPermission());
  }, [dispatch, getStaffPermissionsById]);

  useEffect(() => {
    GetAllStaffPermissions();
    if (staff_id || StaffData?.id) {
      getStaffPermissionsById();
    }

    getClinic();
  }, [GetAllStaffPermissions, getStaffPermissionsById, getClinic]);

  function openClinic() {
    const openNewTabs: any = openInNewTab(`/cms/dashboard/dashboard-clinic`);
    if (openNewTabs) {
      getClinic();
    }
  }

  if (lgUp) {
    return (
      <MuiDrawer variant="permanent" open={drawer}>
        <DHeader drawer={drawer} mobileDrawer={mobileDrawer} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "inherit",
              justifyContent: "space-between",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <List>
              {FilteredSidebarItems?.map((item: any) => (
                <NavItem
                  key={item.id}
                  href={item.href}
                  icon={item.icon}
                  icon2={item.icon2}
                  icon3={item.icon3}
                  title={item.title}
                  drawer={drawer}
                  subItems={item.subItems}
                  isOpen={activeMenuId === item.id}
                  onClick={() => handleMenuClick(item.id)}
                />
              ))}
            </List>
            <List>
              {SidebarOtherItems?.map((item: any) => (
                <NavItem
                  key={item.id}
                  href={item.href}
                  icon={item.icon}
                  title={item.title}
                  drawer={drawer}
                  subItems={item.subItems}
                  isOpen={activeMenuId === item.id}
                  onClick={() => handleMenuClick(item.id)}
                />
              ))}
            </List>
          </Box>
          {parsedData?.clinic_id === undefined ? null : (
            <Box
              sx={{
                backgroundColor: "#01A768",
                position: "relative", // Keeps it consistent with scrolling
              }}
            >
              <List sx={{ backgroundColor: "#01A768" }}>
                {ClinicCms.map((item: any) => (
                  <Box
                    key={item.id} // Ensure the key is on the top-level mapped element
                    onClick={openClinic} // Simplified function call
                  >
                    <NavItem
                      href={item.href}
                      icon={item.icon}
                      title={item.title}
                      drawer={drawer}
                      subItems={item.subItems}
                      isOpen={activeMenuId === item.id}
                      onClick={() => handleMenuClick(item.id)}
                    />
                  </Box>
                ))}
              </List>
            </Box>
          )}
        </Box>
      </MuiDrawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={() => dispatch(handleMobileDrawerClose())}
      open={mobileDrawer}
      PaperProps={{
        sx: {
          width: drawerWidth,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      <DHeader drawer={drawer} mobileDrawer={mobileDrawer} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "inherit",
          justifyContent: "space-between",
        }}
      >
        <List>
          {FilteredSidebarItems.map((item: any) => (
            <>
              <MobileItem
                icon={item.icon}
                title={item.title}
                href={item.href}
                handleMobileDrawerClose={() => {
                  dispatch(handleMobileDrawerClose()); 
                }}
              />
              {item.subItems &&
                item.subItems.map((subItem: any) => (
                  <MobileItem
                    key={subItem.id}
                    href={subItem.href}
                    title={subItem.title}
                    handleMobileDrawerClose={() => {
                      dispatch(handleMobileDrawerClose()); 
                    }}
                  />
                ))}
            </>
          ))}
        </List>
        <List>
          {SidebarOtherItems.map((item: any) => (
            <NavItem
              key={item.id}
              href={item.href}
              icon={item.icon}
              title={item.title}
              drawer={drawer}
              subItems={item.subItems}
              isOpen={activeMenuId === item.id}
              onClick={() => handleMenuClick(item.id)}
            />
          ))}
        </List>
        {parsedData?.clinic_id === undefined ? null : (
          <List style={{ backgroundColor: "#01A768" }}>
            {ClinicCms.map((item: any) => (
              <Box
                onClick={() => {
                  openClinic();
                }}
              >
                <NavItem
                  key={item.id}
                  href={item.href}
                  icon={item.icon}
                  title={item.title}
                  drawer={drawer}
                  subItems={item.subItems}
                  isOpen={activeMenuId === item.id}
                  onClick={() => handleMenuClick(item.id)}
                />
              </Box>
            ))}
          </List>
        )}
      </Box>
    </Drawer>
  );
};

function DHeader({ drawer, mobileDrawer }: any) {
  return (
    <DrawerHeader
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        width: "100%",
        px: 2,
        mb: 1,
      }}
    >
      <Box
        component="img"
        src={drawer || mobileDrawer ? LogoImg : Logo2Img}
        alt="logo"
        sx={{
          width: drawer || mobileDrawer ? "150px" : "28px",
          marginBottom: drawer || mobileDrawer ? "10px" : "0",
          marginTop: drawer || mobileDrawer ? "10px" : "10px",
          marginRight: drawer || mobileDrawer ? "70px" : "0",
        }}
      />
      {drawer && (
        <p style={{ fontSize: "15px", marginBottom: "20px", marginTop: "0px" }}>
          Pharmacy Management System
        </p>
      )}
    </DrawerHeader>
  );
}
